<template>
  <div class="MyMissionDetail">
      <my-header :title="title" :platform="platform"></my-header>
    <div class="mmd_top flex_sb">
      <img :src="d_info.taskImageUrl" class="ming_left" />
      <div class="mmdt_right">
        <div class="title">{{ d_info.taskTitle }}</div>
        <div class="progress">
          当前进度：<span>{{
            d_info.thisGiveCourseNum + "/" + d_info.maxGiveCourseNum
          }}</span
          >，本周还能上传<span>{{ d_info.isUploadImg }}</span
          >次打卡
        </div>
      </div>
    </div>
    <div class="mmd_p1">规则说明</div>
    <div class="mmd_p2" v-html="d_info.taskDesc"></div>
    <div class="mmd_p2">{{'开始时间：'+d_info.taskBeginTime}}</div>
    <div class="mmd_p2">{{'截止时间：'+ d_info.taskEndTime }}</div>
    <div class="mmd_p2" style="color:red">审核周期：4天</div>
    <div class="mmd_p1">截图说明</div>
    <div class="mmd-photo">图片支持jpg、jpeg、bmp、png格式。</div>
    <div class="mmd_p1">
      完成情况：<span class="status_text">{{ taskstatus }}</span>
    </div>
    <div class="mmd_list" v-show="d_list.length != 0">
      <div class="items flex_sb" v-for="(item, index) in d_list" :key="index">
        <div class="time">{{ item.uploadTime }}</div>
        <div class="status">{{ item.uploadState }}</div>
        <div class="reward">{{ item.giveCourseDesc }}</div>
      </div>
    </div>
    <div class="mmd_nomore"></div>
    <div class="mmd_upbtn" v-if="d_info.isUploadImg != 0">
      <div class="up_btn" @click="up_daka">上传打卡</div>
    </div>
    <!-- 打卡弹窗 -->
    <div class="window" @click="show_window=false"  v-show="show_window">
      <div @click.stop="()=>{}" class="w_content upload-pop">
        <!-- <div class="wc_top">
          上传图片
          <div class="close" @click="close"></div>
        </div> -->
        <div class="wc_content upload-img-box">
          <input ref="uploadInput"
            type="file"
            name=""
            id="upfile"
            @change="up_img"
            accept="image/*"
          />
          <img id="upimg" />
          <!-- <div class="othe">
            <img src="/static/mymission/add.png" class="add" />
            <p class="p1">上传图片</p>
            <p class="p2">支持image/jpg, image/jpeg, image/bmp, image/png</p>
          </div> -->
        </div>
        <div class="upload-toast">点击图片可更换</div>
        <div class="wc_submit" @click="submit_daka">提交</div>
      </div>
    </div>
    <div class="gw-pop" v-if="demosticIs">
      <div class="gw-pop-center">
        <div class="demostic-pop">
          <p>{{demosticMsg}}</p>
          <div class="demostic-btn">
            <div class="cancel" @click="demosticCancel">否</div>
            <div class="confirm" @click="demosticConfirm">是</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "../../../service/http";
import IC from "../../../service/imgCompress";

import { Dialog, Loading } from "vant";
import MyHeader from "../common/MyHeader/MyHeader"
export default {
  name: "MyMissionDetail",
  data() {
    return {
      ajaxurl:
        "https://apinew.koalaknow.com/api/OfficialWebSite/InterfaceV1",
      userinfo: {}, //用户的基本信息
      taskId: "", //当前任务id
      d_info: {}, //当前任务详情
      d_list: [], //当前任务完成情况列表
      show_window: false,
      demosticIs:false,
      demosticMsg:'',
      demosticFile: null,
      addFlag:true,
      title:'',
      platform:''
    };
  },
  components: {
    [Dialog.name]: Dialog,
    [Loading.name]: Loading,
    MyHeader
  },
  mounted() {
    document.title = http.getQueryString("title", true);
    this.title = this.$route.query.title||"上传截图";
    this.platform=this.$route.query.platform
    var userinfo = localStorage.getItem("userinfo");
    this.userinfo = JSON.parse(userinfo);

    var imgUrl = "https://www.koalaknow.com/img/VcharImg/vcharlogo.png"; // 分享图标
    var title = "为孩子报名",
      desc = "专业老师，专属课程，爱上“动起来”的中文";
    http.wxshare(
     this.userinfo.userId,
      "https://official.koalaknow.com/MyMission?uid=" +this.userinfo.userId,
      title,
      desc,
      imgUrl
    );

    this.taskId = http.getQueryString("id");
    this.gettask_detail();
  },
  computed: {
    taskstatus() {
      var text = "";
      if (this.d_info.taskState == 1) {
        text = "进行中";
        $(".status_text").css({ color: "#333" });
      } else if (this.d_info.taskState == 2) {
        text = "未开始";
        $(".status_text").css({ color: "#E9A63D" });
      } else if (this.d_info.taskState == 3) {
        text = "已完成";
        $(".status_text").css({ color: "#5DA745" });
      } else if (this.d_info.taskState == 4) {
        text = "已过期";
        $(".status_text").css({ color: "#C3C3C3" });
      }
      return text;
    },
  },
  methods: {
    gettask_detail() {
      $(".mmd_nomore").html("正在加载");
      var data = {
          cmd: "GetUserTaskDetailInfo",
          userGuid: this.userinfo.userGuid,
          taskId: this.taskId,
        },
        that = this;
      http.req(
        data,
        (res) => {
          that.d_info = res.info;
          that.d_list = res.list;
          if (res.list.length == 0) {
            $(".mmd_nomore").html("暂无数据");
          } else {
            $(".mmd_nomore").html("<span>没有更多了</span>");
          }
        },
        this.ajaxurl
      );
    },
    //点击上传打卡
    up_daka() {
    //   this.show_window = true;
        this.$refs.uploadInput.value=''
        this.$refs.uploadInput.click()
    },
    //点击上传图片
    up_img() {
        let that=this
        var file = $(".window #upfile")[0].files[0];
        var reader = new FileReader();
        var imgName = file.name;
        reader.readAsDataURL(file);
        reader.onloadstart = function () {};
        reader.onload = function (e) {
            $(".window #upimg").attr("src", reader.result).show();
            // $(".window .othe").hide();
            that.show_window = true;
        };
    },
    //点击关闭上传打卡弹窗
    close() {
      this.show_window = false;
      $(".window .othe").show();
      $(".window #upimg").hide();
    },

    //点击提交打卡
    submit_daka() {
        var haveimg = $(".window #upimg").css("display"),
            that = this;
        if (haveimg == "none") {
            Dialog({
            title: "请先上传打卡图片",
            className: "Dialog",
            showConfirmButton: false,
            overlayStyle: {
                background: "rgba(0,0,0,0)",
            },
            closeOnClickOverlay: true,
            });
            setTimeout(() => {
            $(".Dialog,.van-overlay").remove();
            }, 2000);
        } else {
            var file = $(".window #upfile")[0].files[0];
            var reader = new FileReader();
            var imgName = file.name;
            reader.readAsDataURL(file);
            IC.photoCompress(
            file,
            {
                quality: 0.5,
            },
            function (base64Codes) {
                const blob = IC.convertBase64UrlToBlob(base64Codes);
                const { lastModified, type } = file;
                const compress_file = new File([blob], imgName, {
                type: type,
                lastModified: lastModified,
                });
                //   imgBase = base64Codes;
                var a = IC.dataURLtoFile(base64Codes);
                // that.PostAjaxFileOSS(a); // 上传file
                that.demosticFile=a
                that.getUserTaskListByPage(a)
            }
            );
        }
    },
    // 是否为国内打卡
    getUserTaskListByPage(file){
      let url='https://apinew.koalaknow.com/api/OfficialWebSite/InterfaceV1'
      let data={
        cmd:'CheckUserIpIsUpload',
      }
       http.req(
        data,
        (res) => {
          if(res.flag==1){
            this.demosticIs=true
            this.demosticMsg=res.msg

          }else{
            this.PostAjaxFileOSS(file)
          }
        },
        url
      );
    },
    // 否
    demosticCancel(){
      this.demosticIs=false
      this.show_window=false;
    },
    // 是
    demosticConfirm(){
      this.PostAjaxFileOSS(this.demosticFile)
    },
    ////上传到阿里云oss
    PostAjaxFileOSS(imgBase) {
      var message =
        '<van-loading size="24px" type="spinner" vertical>正在上传...</van-loading>';
      Dialog({
        message: message,
        className: "Dialog",
        showConfirmButton: false,
        overlayStyle: {
          background: "rgba(0,0,0,0)",
        },
        allowHtml: true,
        closeOnClickOverlay: true,
      });
      var crowd_file = imgBase;
      var formData = new FormData(),that=this;
        formData.append("file", crowd_file);
        if (this.addFlag) {
            this.addFlag = false
            $.ajax({
                type: "POST",
                url: "https://hw.koalaknow.com/UploadFileHandler/UploadFile",
                dataType: "json",
                async: false,
                cache: false,
                data: formData,
                processData: false, // 使数据不做处理
                contentType: false, // 不要设置Content-Type请求头
                success: function (data) {
                var fileUrl = data.url;
                that.func_daka(fileUrl)
                },
                error: function (response) {
                    console.log(response);
                    that.addFlag=true
                },
            });
      }
      
    },
    //执行打卡
    func_daka(uploadImgUrl) {
      var data = {
          cmd: "AddUserTaskDetailList",
          uploadImgUrl: uploadImgUrl,
          taskId: this.taskId,
        },
        that = this;
      http.req(
        data,
          (res) => {
            that.addFlag=true
          if (res.flag == 1) {
            Dialog({
              message: "打卡成功",
              className: "Dialog",
              showConfirmButton: false,
              overlayStyle: {
                background: "rgba(0,0,0,0)",
              },
              allowHtml: true,
              closeOnClickOverlay: true,
            });
            that.demosticIs=false
            that.show_window=false;
            that.gettask_detail();
          }else{
              Dialog({
              message:res.msg,
              className: "Dialog",
              showConfirmButton: false,
              overlayStyle: {
                background: "rgba(0,0,0,0)",
              },
              allowHtml: true,
              closeOnClickOverlay: true,
            });
          }
            setTimeout(() => {
              $(".Dialog,.van-overlay").remove();
            }, 2000);
        },
        this.ajaxurl
      );
    },
  },
};
</script>
<style scoped>
.MyMissionDetail {
  min-height: 100vh;
  background: #fff;
  padding: 40px 30px 120px;
  box-sizing: border-box;
  position: relative;
}
.mmd_top .ming_left {
  width: 128px;
  height: 128px;
  margin: 0;
}
.mmd_top .mmdt_right {
  margin: 0 0 0 30px;
  flex: 1;
  -webkit-flex: 1;
}
.mmd_top .mmdt_right .title {
  color: #333;
  font-size: 32px;
  font-weight: bold;
  line-height: 42px;
  margin: 0 0 24px 0;
}
.mmd_top .mmdt_right .progress {
  color: #474747;
  font-size: 24px;
  line-height: 31px;
}
.mmd_top .mmdt_right .progress span {
  color: #ff2424;
}
.MyMissionDetail .mmd_p1 {
  color: #333;
  font-size: 28px;
  margin: 30px 0 12px 0;
  font-weight: bold;
  line-height: 37px;
}
.MyMissionDetail .mmd_p2 {
  font-size: 24px;
  line-height: 36px;
  color: #333333;
}
.mmd-photo{
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    margin-top: 20px;
}
.mmd_list {
  border-top: 1px solid #cccccc;
}
.mmd_list .items {
  padding: 14px 30px;
  box-sizing: border-box;
  color: #666666;
  font-size: 24px;
  line-height: 31px;
  border-bottom: 1px solid #cccccc;
}
.mmd_list .items .time {
  width: 180px;
}
.mmd_list .items .status {
  width: 110px;
  text-align: center;
}
.mmd_list .items .reward {
  flex: 1;
  -webkit-flex: 1;
  text-align: right;
}
.mmd_nomore {
  color: #cccccc;
  font-size: 24px;
  line-height: 86px;
  text-align: center;
}
.mmd_upbtn {
  position: fixed;
  width: 100%;
  height: 120px;
  background: #ffffff;
  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.1);
  bottom: 0;
  left: 0;
}
.mmd_upbtn .up_btn {
  width: 600px;
  height: 88px;
  background: #e0382d;
  opacity: 1;
  border-radius: 44px;
  margin: 16px auto;
  font-size: 32px;
  color: #fff;
  font-weight: bold;
  line-height: 88px;
  text-align: center;
}
.w_content {
  border-radius: 10px;
  width: 80%;
  padding: 10px 30px 14px;
  box-sizing: border-box;
  background: #fff;
}
.window .upload-pop{
    width: 100%;
    min-height: 1130px;
    position: absolute;
    top: auto;
    left: 0;
    bottom: 0;
    transform: initial;
    border-radius: 30px 30px 0px 0px;
    padding-top: 60px;
    padding-bottom: 10px;
    box-sizing: border-box;
    padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
    padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}
.wc_top {
  position: relative;
  color: #333333;
  font-size: 24px;
  font-weight: bold;
  line-height: 71px;
  border-bottom: 1px solid #cccccc;
}
.wc_top .close {
  width: 20px;
  height: 20px;
  background: url("/static/mymission/close0.png");
  background-size: 100% 100%;
  position: absolute;
  right: 0;
  top: 10px;
}
.wc_top .close:active {
  background: url("/static/mymission/close1.png");
  background-size: 100% 100%;
}
.w_content .upload-img-box {
  width: 450px;
  height: 800px;
  /* background: #DDE9FF; */
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  text-align: center;
}
.wc_content #upfile,
.wc_content #upimg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.wc_content #upfile {
  opacity: 0;
  z-index: 2;
}
.wc_content #upimg {
  object-fit: contain;
  display: none;
}
.wc_content .add {
  width: 61px;
  margin: 70px auto 10px;
}
.wc_content .p1 {
  color: #333333;
  font-size: 20px;
  line-height: 49px;
}
.wc_content .p2 {
  color: #999999;
  font-size: 18px;
  line-height: 40px;
}
.upload-toast{
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    margin-top: 10px;
    text-align: center;
}
.w_content .wc_submit {
    width: 400px;
    height: 80px;
    background: #F43737;
    border-radius: 40px;
    font-size: 32px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 80px;
    margin: 17px auto 0;
    text-align: center;
}


/* 国内打卡弹框 */
.gw-pop{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.5);
}
.gw-pop-center{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
}
.demostic-pop{
  width: 84vw;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
  padding:30px ;
  text-align: center;
  font-size: 28px;
  color: #222;
  line-height: 48px;
}
.demostic-btn{
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
}
.demostic-btn div{
  width: 270px;
  height: 80px;
  line-height: 80px;
  border-radius: 40px;
  box-sizing: border-box;
}
.cancel{
  border: 2px solid #ddd;
  font-size: 32px;
  color: #999;
  font-weight: bold;
}
.confirm{
  background: #EA2737;
  color: #fff;
  font-size: 32px;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/content/MyMissionDetail.vue